let dash = null;

export async function dashjs() {
  if (dash == null)
    dash = await import(
      /* webpackChunkName: "Dash" */
      /* webpackMode: "lazy" */
      'dashjs/dist/dash.mediaplayer.debug'
    );

  return dash;

}
